import {EditIntegrationCommonPropsType} from "../../../../types";
import {Flex} from "../../../../../../../newShared/components/Layouts";
import * as S from '../../../styled';
import React from "react";
import {LoadingButton} from "../../../../../../../newShared/components/Basic/CommonButtons";
import {useMainTranslation} from "../../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useEditZendesk} from "../../../../hooks/integrationsManagement/editIntegrationComponents/zendesk";
import {Button, Icon} from "@mui/material";
import {useDispatch} from "react-redux";
import {useOAuth2} from "../../../../../../../newShared/components/oauth";
import {ZENDESK_CLIENTID, ZENDESK_REDIRECT_URI, ZENDESK_SCOPE, ZENDESK_URL} from "../../../../constants";
import {addErrorSnack} from "../../../../../../barsEnvironment/snack/store/slice";

export const EditIntegrationZendesk = (props: EditIntegrationCommonPropsType) => {
    const {
        form,
        actions,
        isOk,
        isLoading
    } = useEditZendesk(props);
    const {revDir, t} = useMainTranslation('', {keyPrefix: 'pathIntegrations.AvailableAppsList.dialogs'});

    const dispatch = useDispatch();
    const zendesk = useOAuth2<{code: string}>({
        authorizeUrl: ZENDESK_URL,
        clientId: ZENDESK_CLIENTID,
        redirectUri: ZENDESK_REDIRECT_URI,
        scope: ZENDESK_SCOPE,
        responseType: "code",
        exchangeCodeForTokenServerURL: "",
        // exchangeCodeForTokenMethod: "POST",
        // extraQueryParameters:{
        //     audience: "https://api.atlassian.com",
        //     prompt:"consent"
        // },

        onSuccess: (res) => {
            res.code && actions.setForm(prev => ({...prev, integration: {...prev.integration, authorization_code: res.code}}));
        },
        onError: (error_) => dispatch(addErrorSnack(`Error while connecting to zendesk: ${error_}`))
    });

    return(
        <S.AppConfigContainer>
            <S.TextFieldCustom
                variant={'outlined'}
                name={'name'}
                label={t('Application name')}
                value={form.name}
                onChange={actions.handleChange}
                size={'small'}
            />

            {/*<S.TextFieldCustom*/}
            {/*    variant={'outlined'}*/}
            {/*    name={'authorization_code'}*/}
            {/*    label={'Authorization code'}*/}
            {/*    value={form.integration.authorization_code}*/}
            {/*    onChange={actions.handleChangeIntegration}*/}
            {/*    sx={{margin: '16px 0 0 0'}}*/}
            {/*    size={'small'}*/}
            {/*/>*/}

            <Button variant={"outlined"} style={{margin: '16px 0 0 0'}} color={form.integration.authorization_code.trim().length > 0 ? 'success' : undefined}
                    startIcon={<Icon><img src={'https://cdn.svgporn.com/logos/zendesk-icon.svg?response-content-disposition=attachment%3Bfilename%3Dzendesk-icon.svg'} alt={'zendesk icon'} style={{maxHeight: '100%', maxWidth: '100%'}}/></Icon>}
                    onClick={() => zendesk.getAuth()}>
                {t('Sign in with Zendesk')}
            </Button>

            <Flex w={'100%'} jc={'flex-end'} m={'16px 0 0 0'}>
                <LoadingButton
                    sx={{margin: !revDir ? '0 16px 0 0' : '0 0 0 16px'}}
                    loading={isLoading}
                    onClick={actions.handleSubmit}
                    disabled={!isOk}
                >
                    {t('Save')}
                </LoadingButton>
            </Flex>
        </S.AppConfigContainer>
    )
}